import { stats, partners } from '@/mocks/soniem';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Images */}
          <div className="relative">
            <div className="flex gap-4">
              <div className="w-[45%] pt-8">
                <div className="rounded-2xl overflow-hidden h-[280px] md:h-[360px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20interior%20of%20a%20modern%20music%20institution%20office%20in%20Lima%20Peru%2C%20warm%20lighting%2C%20professional%20atmosphere%2C%20dark%20wood%20and%20red%20accent%20decor%2C%20clean%20modern%20design%2C%20architectural%20photography%2C%20sophisticated%20corporate%20space%2C%20natural%20light%20from%20large%20windows&width=600&height=900&seq=soniem-about-01&orientation=portrait"
                    alt="Oficina institucional SONIEM en San Miguel"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="w-[55%]">
                <div className="rounded-2xl overflow-hidden h-[340px] md:h-[440px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20music%20recording%20studio%20with%20modern%20equipment%20and%20warm%20ambient%20lighting%2C%20acoustic%20panels%2C%20microphone%20on%20stand%2C%20mixing%20console%2C%20dark%20red%20and%20charcoal%20aesthetic%2C%20professional%20studio%20photography%2C%20inviting%20creative%20space%2C%20clean%20and%20organized&width=700&height=1000&seq=soniem-about-02&orientation=portrait"
                    alt="Estudio de grabación SONIEM"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            {/* Floating stat card */}
            <div className="absolute -bottom-6 left-4 md:left-8 bg-background-50 rounded-2xl px-6 py-5 border border-secondary-200/60">
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-500">13</span>
              <p className="text-foreground-600 text-xs md:text-sm mt-1 whitespace-nowrap">Años de trayectoria</p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-4">
              Sobre SONIEM
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-6">
              La voz de los artistas{' '}
              <span className="text-primary-500">musicales</span> del Perú
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-6">
              La Sociedad Nacional de Intérpretes y Ejecutantes de la Música es una entidad 
              privada sin fines de lucro, autorizada por el Indecopi mediante Resolución 
              Nº 0054-2011/DDA-INDECOPI del 22 de julio de 2011.
            </p>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              Nuestra misión es proteger, administrar y recaudar las regalías por el derecho 
              de propiedad intelectual de intérpretes y ejecutantes musicales, asegurando una 
              remuneración justa por el uso de sus grabaciones.
            </p>

            {/* Stats Row */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50 border border-secondary-100">
                  <span className="block font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    {stat.value}
                  </span>
                  <span className="text-foreground-500 text-xs md:text-sm whitespace-nowrap">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            {/* Partners */}
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
                Convenios y alianzas
              </p>
              <div className="flex flex-wrap gap-3">
                {partners.map((partner) => (
                  <span
                    key={partner.name}
                    className="px-4 py-2 rounded-full bg-secondary-100 text-foreground-700 text-xs md:text-sm font-medium whitespace-nowrap"
                    title={partner.description}
                  >
                    {partner.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}